import { render, staticRenderFns } from "./wishlist-fit-zwifloc.vue?vue&type=template&id=7f970300&scoped=true"
import script from "./wishlist-fit-zwifloc.vue?vue&type=script&lang=js"
export * from "./wishlist-fit-zwifloc.vue?vue&type=script&lang=js"
import style0 from "./wishlist-fit-zwifloc.vue?vue&type=style&index=0&id=7f970300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f970300",
  null
  
)

export default component.exports